import apiClient from './client';
import { Subject } from './subjects';

export interface ExamType {
  id: string;
  slug: string;
  name: string;
  description: string | null;
  time_limit_minutes: number | null;
  config: Record<string, any> | null;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface DtmDirection {
  id: string;
  exam_type_id: string;
  name: string;
  slug: string;
  primary_subject_id: string;
  secondary_subject_id: string;
  primary_subject?: Subject;
  secondary_subject?: Subject;
  primary_question_count: number;
  secondary_question_count: number;
  primary_score_per_question: number;
  secondary_score_per_question: number;
  sort_order: number;
  is_active: boolean;
}

export interface CreateExamTypeDto {
  slug: string;
  name: string;
  description?: string | null;
  time_limit_minutes?: number | null;
  config?: Record<string, any> | null;
}

export interface UpdateExamTypeDto {
  name?: string;
  description?: string | null;
  time_limit_minutes?: number | null;
  config?: Record<string, any> | null;
  is_active?: boolean;
}

export interface CreateDtmDirectionDto {
  exam_type_id: string;
  name: string;
  slug: string;
  primary_subject_id: string;
  secondary_subject_id: string;
  primary_question_count?: number;
  secondary_question_count?: number;
  primary_score_per_question?: number;
  secondary_score_per_question?: number;
  sort_order?: number;
}

export interface UpdateDtmDirectionDto {
  name?: string;
  primary_question_count?: number;
  secondary_question_count?: number;
  primary_score_per_question?: number;
  secondary_score_per_question?: number;
  sort_order?: number;
  is_active?: boolean;
}

export const examsApi = {
  getExamTypes: async (): Promise<ExamType[]> => {
    const response = await apiClient.get<ExamType[]>('/exam-types');
    return response.data;
  },

  getExamTypeBySlug: async (slug: string): Promise<ExamType> => {
    const response = await apiClient.get<ExamType>(`/exam-types/${slug}`);
    return response.data;
  },

  createExamType: async (dto: CreateExamTypeDto): Promise<ExamType> => {
    const response = await apiClient.post<ExamType>('/admin/exam-types', dto);
    return response.data;
  },

  updateExamType: async (id: string, dto: UpdateExamTypeDto): Promise<ExamType> => {
    const response = await apiClient.patch<ExamType>(`/admin/exam-types/${id}`, dto);
    return response.data;
  },

  deleteExamType: async (id: string): Promise<void> => {
    await apiClient.delete(`/admin/exam-types/${id}`);
  },

  getDirections: async (): Promise<DtmDirection[]> => {
    const response = await apiClient.get<DtmDirection[]>('/dtm-directions');
    return response.data;
  },

  getDirectionById: async (id: string): Promise<DtmDirection> => {
    const response = await apiClient.get<DtmDirection>(`/dtm-directions/${id}`);
    return response.data;
  },

  createDirection: async (dto: CreateDtmDirectionDto): Promise<DtmDirection> => {
    const response = await apiClient.post<DtmDirection>('/admin/dtm-directions', dto);
    return response.data;
  },

  updateDirection: async (id: string, dto: UpdateDtmDirectionDto): Promise<DtmDirection> => {
    const response = await apiClient.patch<DtmDirection>(`/admin/dtm-directions/${id}`, dto);
    return response.data;
  },

  deleteDirection: async (id: string): Promise<void> => {
    await apiClient.delete(`/admin/dtm-directions/${id}`);
  },
};
